import { message } from 'antd';
import { TFunction } from 'i18next';

export async function copyToClipboard(
  text: string,
  t: TFunction,
  successMessage: string
) {
  if (!text) return;
  try {
    await navigator.clipboard.writeText(text);
    message.open({
      type: 'success',
      content: successMessage,
      className: 'response-success',
    });
  } catch {
    message.open({
      type: 'error',
      content: t('errors.clipboard.copyFailed'),
      className: 'response-error',
    });
  }
}
